module.exports = __webpack_public_path__ + "static/media/sustainableProducts.afdaed91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tradingPreferences/sustainableProducts.svg
// module id = 350
// module chunks = 21